/*
  Tokyo Romance Club — Back to Top button.
  Not rendered at all in the theme editor (see trc-back-to-top.liquid), so no
  design-mode guard is needed here.
*/
(function () {
  if (window.__trcBackToTopInit) return;
  window.__trcBackToTopInit = true;

  var SHOW_AFTER = 700;
  var button = document.getElementById('trc-back-to-top');
  if (!button) return;

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {}

  var ticking = false;

  function update() {
    ticking = false;
    var visible = window.scrollY > SHOW_AFTER;
    if (visible) {
      button.hidden = false;
      requestAnimationFrame(function () {
        button.setAttribute('data-visible', 'true');
      });
    } else {
      button.setAttribute('data-visible', 'false');
      if (reduceMotion) {
        button.hidden = true;
      }
    }
  }

  button.addEventListener('transitionend', function () {
    if (button.getAttribute('data-visible') === 'false') {
      button.hidden = true;
    }
  });

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    },
    { passive: true }
  );

  button.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
  });

  update();
})();
